import { connect } from "react-redux";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";
import ListView from "@/common/custom-lists/ListView";
import ReportsBulkClientsRow from "./ReportsBulkClientsRow";
import { orderBy } from "lodash";

const ReportsBulkClients = ({ organisations, reportPacks, saveReportPacks, reportPackOptions }) => {
	const columns = [{ hidden: true }, "Company", "Apply Reports Packs", { hidden: true }];

	return (
		<div className="mt-10">
			<ListView
				{...{
					title: "Client",
					items: organisations?.map((organisation) => {
						const updateApplied = (appliedReportPacks) => {
							const newReportPacks = [...reportPacks];

							newReportPacks.forEach((reportPack) => {
								const orgIndex = reportPack.appliedOrgs.indexOf(organisation.id);
								if (orgIndex !== -1) {
									reportPack.appliedOrgs.splice(orgIndex, 1);
								}
							});

							// Early return if appliedReportPacks is empty
							if (!appliedReportPacks || appliedReportPacks.length === 0)
								return saveReportPacks(newReportPacks);

							appliedReportPacks.forEach((reportPack) => {
								const reportIndex = newReportPacks.findIndex((pack) => pack.id === reportPack.value);

								// Proceed only if a matching report pack is found
								if (reportIndex !== -1) {
									newReportPacks[reportIndex].appliedOrgs.push(organisation.id);
								}
							});

							saveReportPacks(newReportPacks);
						};

						const appliedReportPacks = reportPacks.filter((reportPack) =>
							reportPack.appliedOrgs.includes(organisation.id),
						);

						return (
							<ReportsBulkClientsRow
								organisation={organisation}
								reportPackOptions={reportPackOptions}
								appliedReportPacks={appliedReportPacks}
								updateApplied={updateApplied}
							/>
						);
					}),
					columns,
				}}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	const advisorCompanies = state?.organisations?.filter((c) => c.isAdvisor);

	const reportPacks = state.advisors?.reports?.reportPacks || [];
	const reportPackOptions = reportPacks.map((reportPack) => ({
		value: reportPack.id,
		label: reportPack.name,
	}));

	return {
		organisations: orderBy(advisorCompanies, ["name"], ["asc"]),
		reportPacks,
		reportPackOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveReportPacks: (reportPacks) => dispatch(REPORTACTIONS.postReportPacks(reportPacks)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsBulkClients);
